import type { ReviewHold, ReviewHolder, SongRequest } from '../services/requests';

export const HOLD_MS = 120_000;
export const HOLD_WARNING_MS = 30_000;
export const RENEW_THROTTLE_MS = 30_000;

export type HoldWarning = 'none' | 'soon' | 'expired';

// A helper's hold only counts while their link is active, so a revoked link never blocks the DJ
export function isHeldByOther(
  request: Pick<SongRequest, 'reviewHold'>,
  me: ReviewHolder,
  nowMs: number,
  helperActive: boolean
): boolean {
  const hold = request.reviewHold;
  if (!hold || hold.holder === me || hold.untilMs <= nowMs) return false;
  return hold.holder !== 'coApprovalDj' || helperActive;
}

export function holdWarning(untilMs: number, nowMs: number): HoldWarning {
  if (untilMs <= nowMs) return 'expired';
  return untilMs - nowMs <= HOLD_WARNING_MS ? 'soon' : 'none';
}

export function holderLabel(hold: ReviewHold | null | undefined): string {
  if (!hold) return '';
  if (hold.holder === 'dj') return 'DJ';
  return hold.name || 'Your co-approval DJ';
}

// Mirrors isOnCoApprovalDjList in functions/src/utils/djReview.ts: attendee songs still with the DJ side
export function isOnCoApprovalDjList(
  request: Pick<SongRequest, 'status' | 'practiceMode' | 'requestedBy' | 'superRequest' | 'poolApproved' | 'coApprovalStatus'>,
  coApprovalEnabled: boolean,
  djId: string
): boolean {
  if (request.status !== 'pending' || request.practiceMode === true) return false;
  if (request.requestedBy.oderId === djId) return false;
  if (request.superRequest === true && request.poolApproved === true) return false;
  if (coApprovalEnabled && request.coApprovalStatus === 'pending') return false;
  return request.coApprovalStatus !== 'rejected';
}
